
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/how-the-right-playlist-can-increase-restaurant-sales",
      function () {
        return require("private-next-pages/articles/how-the-right-playlist-can-increase-restaurant-sales.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/how-the-right-playlist-can-increase-restaurant-sales"])
      });
    }
  